import React, { useEffect, useState } from "react";
import "./IsoCards.css";
import { Link } from "react-router-dom";

const IsoCard = () => {
  const [courses, setCourses] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const cleanHTML = (text) => {
    if (!text) return "";

    return text
      .replace(/<(?!\/?(b|strong)\b)[^>]*>/gi, "") // keep <b>, <strong>
      .replace(/&nbsp;/g, " ");
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}courses`,
        );
        const data = await res.json();

        if (data.status) {
          setCourses(data.data);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchCourses();
  }, []);

  return (
    <section className="isoStandards-training-section">
      <div className="isoStandards-container">
        <div className="isoStandards-training-grid">
          {courses.map((card, index) => (
            <div className="isoStandards-training-card" key={index}>
              <div className="isoStandards-card-header">
                <div className="isoStandards-top-tags">
                  <span className="isoStandards-tag-pill">{card.badge}</span>
                  <span className="isoStandards-tag-pill white">
                    {card.duration}
                  </span>
                </div>

                <h3>{card.title}</h3>
                <p className="isoStandards-iso-sub">{card.category}</p>
              </div>

              <div className="isoStandards-card-body">
                {/* <p className="isoStandards-price-label">Fees per participant</p> */}

                <h4 className="isoStandards-price">{card.fees}</h4>

                {/* <p className="isoStandards-description">
                    {(card.short_description).slice(0, 100)}
                    {(card.short_description && card.short_description > 100) && "..."}
                  </p> */}

                {/* <p
                  dangerouslySetInnerHTML={{
                    __html: cleanHTML((card.short_description).slice(0, 100)),
                  }}
                /> */}
                <p
                  className="two-line-text"
                  dangerouslySetInnerHTML={{
                    __html: cleanHTML(card.short_description),
                  }}
                />

                {card.slug && (
                  <Link
                    to={`/iso/${card.slug}`}
                    className="isoStandards-btn-enquire"
                  >
                    Learn More
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IsoCard;
